import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import api from '../../services/api';
import { FormGroup, Container } from '@mui/material';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import { useStyles } from '../../components/Styles';
import GroupButton from '../../components/Buttons/ButtonGroup';
import TextFieldCustom from '../../components/Inputs/TextField/TextField';

function Equipment() {
  const [openProgress, setOpenProgress] = useState(false);
  // const [selectedEquipment, handleSelectedEquipment] = useState(null);
  // const [selectedPond, handleSelectedPond] = useState(null);

  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const classes = useStyles();

  const formik = useFormik({
    initialValues: {
      name: '',
      type: '',
      energyConsumption: null,
      description: '',
    },
    validationSchema: Yup.object({
      energyConsumption: Yup.number()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua a quantidade energia',
        )
        .integer('O valor deve ser um número inteiro')
        .nullable(),
      name: Yup.string().required('Campo Obrigatório'),
      type: Yup.string().required('Campo Obrigatório'),
      description: Yup.string().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));

      request(values);
    },
  });

  useEffect(() => {
    async function load() {
      // carrega o viveiro caso tenha id, do contrario carrega vazio para cadastrar um novo
      setOpenProgress(true);

      if (id) {
        const request = await api.get(`/equipments/${id}`);
        formik.setValues(request.data);

        // handleSelectedPond(request.data.cycle.pond);
        // handleSelectedEquipment(request.data.equipment);

        formik.values.equipment = request.data.equipment;
      }
      setOpenProgress(false);
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      id
        ? await api.put(`/equipments/${id}`, { ...data })
        : await api.post('/equipments', { ...data });
      success();
      history.push('/equipments');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      <form onSubmit={formik.handleSubmit}>
        <form className={classes.root}>
          <h2 className="title">Controle de Equipamentos</h2>
          <TextFieldCustom
            id="name"
            label="Nome"
            formik={formik}
            value={formik.values.name}
            errorAndHelper="name"
            onChange={(e) => {
              formik.setFieldValue('name', e.target.value);
            }}
          />

          <TextFieldCustom
            id="type"
            label="Tipo"
            formik={formik}
            value={formik.values.name}
            errorAndHelper="type"
            onChange={(e) => {
              formik.setFieldValue('type', e.target.value);
            }}
          />
          <FormGroup>
            <TextFieldCustom
              id="Consumo"
              label="Consumo estimado (em kWh)"
              type="number"
              formik={formik}
              value={formik.values.energyConsumption}
              errorAndHelper="energyConsumption"
              onChange={(e) => {
                formik.setFieldValue('energyConsumption', e.target.value !== '' ? parseFloat(e.target.value) : 0);
              }}
            />
          </FormGroup>
          <TextFieldCustom
            id="description"
            label="Descrição"
            formik={formik}
            value={formik.values.description}
            multiline
            onChange={(e) => formik.setFieldValue('description', e.target.value)}
          />
        </form>

        <GroupButton
          deleteRoute="/equipments/"
          routeDelete="/equipments/"
          returnRoute="/equipments/"
          id={id}
          disable={disable}
          message="INSERIR MENSAGEM"
        />
      </form>
    </Container>
  );
}

export default Equipment;
